{
  "pt": {
    "task_assignment": {
      "actions": {
        "add_assignee": "Adicionar um responsável",
        "bulk_remove": "Remover da tarefa",
        "change_status": "Alterar estado",
        "confirm": "Marcar como concluída",
        "create": "Tarefa",
        "delete": "Eliminar responsável",
        "document_add": "Adicionar ficheiro",
        "document_delete": "Eliminar",
        "due_in_month": "Dentro de um mês",
        "due_in_two_weeks": "Dentro de duas semanas",
        "due_in_week": "Dentro de uma semana",
        "due_remove": "Remover prazo",
        "move_to_draft": "Colocar em rascunho",
        "open": "Abrir",
        "reopen": "Reabrir",
        "selectAll": "Selecionar todas ({total})",
        "send_and_notify": "Enviar e notificar",
        "set_due_date": "Definir prazo",
        "set_status": "Definir estado",
        "unSelectAll": "Desmarcar tudo",
        "upload_files": "Carregar {count} ficheiro | Carregar {count} ficheiros"
      },
      "assignee_scopes": {
        "external": "Externo",
        "internal": "Interno"
      },
      "assignee_types": {
        "customer": "Cliente",
        "employee": "Membro da equipa",
        "partner": "Parceiro"
      },
      "attributes": {
        "assignee": "Responsável",
        "assignees": "Responsáveis",
        "comment": "Comentário",
        "created_at": "Criado",
        "document": "Documento",
        "due_date": "Prazo",
        "project": "Projeto",
        "status": "Estado",
        "task": "Tarefa",
        "unit": "Unidade"
      },
      "confirm": {
        "affected": "Isto afeta {customers} e {team}.",
        "affected_customers": "Isto afeta {customers}.",
        "affected_team": "Isto afeta {team}.",
        "bulk_affected": "Isto escreve {count} tarefa. | Isto escreve {count} tarefas.",
        "bulk_delete_body": "A tarefa continua a existir, nesta unidade e em todas as outras. Apenas as linhas selecionadas desaparecem.",
        "bulk_delete_header": "Remover estas tarefas?",
        "complete_body": "As tarefas deles ficam fechadas e desaparecem da lista, mesmo que não tenham feito nada.",
        "complete_header": "Fechar esta tarefa para todos?",
        "customer_tasks": "{count} tarefa de cliente | {count} tarefas de cliente",
        "delete_body": "Só esta atribuição desaparece. A tarefa mantém os seus outros responsáveis e as suas outras unidades.",
        "delete_header": "Eliminar {name} desta tarefa?",
        "delete_sent_customers": "Esta já tinha sido enviada, por isso desaparece também do portal de clientes de {unit}.",
        "delete_sent_team": "Esta já tinha sido enviada, por isso desaparece também da lista de {name}.",
        "document_delete_body": "O ficheiro desaparece também dos documentos da unidade.",
        "document_delete_header": "Eliminar este ficheiro?",
        "draft_body": "A tarefa desaparece até ser enviada outra vez. Os e-mails que já saíram continuam enviados.",
        "draft_header": "Voltar a colocar esta tarefa em rascunho?",
        "send_customers": "Os clientes veem a tarefa de imediato no portal e recebem uma notificação.",
        "send_header": "Enviar para os responsáveis?",
        "send_permanent": "O envio não pode ser anulado. Voltar a colocar a tarefa em rascunho mais tarde não retira a notificação.",
        "send_status": "Ficam em Solicitado.",
        "send_team": "Os membros da equipa são notificados.",
        "team_tasks": "{count} tarefa de equipa | {count} tarefas de equipa"
      },
      "deep_link": {
        "completed": "Esta tarefa já está concluída.",
        "gone": "Esta tarefa já não está aberta."
      },
      "empty": {
        "filtered_description": "Ajusta os teus filtros ou limpa-os para veres todas as atribuições.",
        "filtered_title": "Nenhuma atribuição corresponde aos teus filtros",
        "none_title": "Sem atribuições"
      },
      "filters": {
        "due_window_values": {
          "month": "Prazo dentro de um mês",
          "none": "Sem prazo",
          "overdue": "Em atraso",
          "week": "Prazo dentro de uma semana"
        },
        "show_only": "Mostrar apenas",
        "show_only_values": {
          "customers": "Clientes",
          "mine": "Atribuídas a mim",
          "team": "Equipa"
        }
      },
      "labels": {
        "add_assignee": "Adicionar responsável",
        "add_customers": "Adicionar clientes",
        "already_assigned": "Esta tarefa já foi adicionada a esta unidade.",
        "already_assigned_project": "Esta tarefa já foi adicionada a este projeto.",
        "assignees": "Atribuídos",
        "assignees_subtitle": "Cada um recebe a sua própria tarefa, por unidade.",
        "assignees_title": "Quem deve fazer",
        "comment_earlier_round": "ronda anterior",
        "comment_placeholder": "p. ex. o contador era difícil de alcançar, esta é a melhor foto que consegui tirar",
        "comments_none": "O cliente não deixou nenhum comentário.",
        "comments_title": "Comentários sobre esta tarefa",
        "completed": "Concluídas",
        "confirm_message": "Tem a certeza de que pretende marcar esta tarefa como concluída?",
        "customers": "Clientes",
        "documents_none": "Ainda não foi carregado nada.",
        "documents_title": "Ficheiros desta tarefa",
        "earlier": "+{count} anteriores",
        "my_tasks": "As minhas tarefas",
        "no_assignees": "Ainda não há responsáveis.",
        "no_assignments": "Ainda não há tarefas.",
        "no_assignments_task": "Ainda não há atribuições para esta tarefa.",
        "no_assignments_unit": "Ainda não há tarefas para esta unidade.",
        "previous_upload": "carregamento anterior",
        "required": "Este campo é obrigatório",
        "selectOne": "Selecione pelo menos uma tarefa.",
        "select_task": "Selecione uma tarefa",
        "selected": "{selected} selecionada | {selected} selecionadas",
        "set_status_for": "Definir o estado de {name}",
        "superseded": "substituído",
        "totalSelected": "Todas as {total} selecionadas",
        "upload_hint": "Carregue o(s) documento(s) solicitado(s) para concluir esta tarefa.",
        "uploaded_documents": "Documentos carregados"
      },
      "statuses": {
        "completed": "Concluído",
        "draft": "Rascunho",
        "requested": "Solicitado"
      },
      "toasts": {
        "bulk_delete": "Tarefas removidas",
        "bulk_update": "Tarefas atualizadas",
        "completed": "Tarefa concluída",
        "create": "Tarefa criada",
        "delete": "Responsável eliminado",
        "document_added": "Ficheiro adicionado",
        "document_deleted": "Ficheiro eliminado",
        "reopened": "Tarefa reaberta",
        "update": "Tarefa atualizada"
      }
    }
  }
}
